import styled from 'styled-components';

import { colors, radius } from '../../styles/tokens';

export const Container = styled.button`
  min-width: 250px;
  height: 110px;
  width: 100%;
  border-radius: ${radius.md};

  text-decoration: none;

  border: 1px solid ${colors.outlineVariant};

  display: flex;
  align-items: center;

  background: ${colors.surfaceContainerLow};

  transition: background-color 0.3s;

  &:hover {
    background-color: ${colors.surfaceContainer};
  }

  span {
    font-size: 32px;
    font-weight: 600;
    color: ${colors.onSurface};
    margin-left: 20px;
  }

  @media (max-width: 1199px) {
    height: 80px;
  }
`;

export const ContainerImg = styled.div`
  margin-left: 20px;
  width: 80px;
  height: 80px;

  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  img {
    max-height: 100%;
    width: auto;
  }

  @media (max-width: 1199px) {
    width: 50px;
    height: 50px;
  }
`;

export const ContainerName = styled.div`
  display: flex;
  align-items: center;
  span {
    font-size: 32px;
  }

  @media (max-width: 1199px) {
    span {
      font-size: 24px;
    }
  }
`;
